import React, {useState} from "react";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import IconButton from "@mui/material/IconButton";


export const useExpandButtonIcon = (props={}) => {
    const {height="300px", expandedHeight="700px"} = props;

    const [mapExpanded, setMapExpanded] = useState(false);
    const mapHeight = mapExpanded[0] ? expandedHeight : height;

    const toggleMapExpanded = () => setMapExpanded(prev => [!prev[0]]);

    return {mapExpanded, toggleMapExpanded, mapHeight};
}

export const ExpandButtonIcon = ({mapExpanded, toggleMapExpanded}) => {
    return <IconButton onClick={toggleMapExpanded} color="info" size="small" variant='outlined'>
        {mapExpanded[0] ? <CloseFullscreenIcon /> : <OpenInFullIcon/> }
    </IconButton>
}

